import { useAtomValue, useSetAtom } from 'jotai';
import { activeConversationIdAtom, activeTabNameAtom } from '../store';
import { filterData } from './useInfiniteConversationsByType';
import useMessagesFilterSelectedValues from './useMessagesFilterSelectedValues';
import { TabNames } from '../constants';
import useConversationsQueries from './useConversationsQueries';

const useSelectFirstConversationInTab = () => {
  const activeTabName = useAtomValue(activeTabNameAtom);
  const setActiveConversationId = useSetAtom(activeConversationIdAtom);
  const filterSelectedValues = useMessagesFilterSelectedValues();
  const { isUnreadMessagesFilterSelected } = filterSelectedValues;
  const conversationData = useConversationsQueries();

  const selectFirstConversation = (tabName = activeTabName) => {
    if (isUnreadMessagesFilterSelected) {
      // do not select first conversation when unread message filter is active - would trigger marking as read
      return;
    }

    const conversationsTabData = conversationData[TabNames[tabName]]?.query;

    if (conversationsTabData) {
      const filteredData = filterData(filterSelectedValues)(conversationsTabData);
      const firstConversationId = filteredData.pages[0]?.data?.[0]?.conversation_id;
      if (firstConversationId) {
        setActiveConversationId(firstConversationId);
      }
    }
  };

  return selectFirstConversation;
};

export default useSelectFirstConversationInTab;
